export default __webpack_public_path__ + "static/screenshot-2-df244168b877ed82d4928c0938b3acd3.png";